<template>
  <div :key="goalsContainerKey" ref="listContainer">
    <goal-viewer
      v-for="goal in goals"
      :key="goal.id"
      :data-id="goal.id"
      :goal-id="goal.id"
      :show-gripper="true"
      :show-timeline="false"
      :show-child-goals="true"
      :selected-timeline="selectedTimeline"
      :source="source"
      :level="0"
      @delete-goal="$emit('delete-goal')"
      @archive-goal="$emit('archive-goal')"
      @move-goal="$emit('move-goal')"
      class="draggable-item"
    ></goal-viewer>
  </div>
</template>

<script>
import { trackEvent } from '@/analytics'
import GoalViewer from '@/components/GoalViewer'
import { EVENT_ACTION, EVENT_CATEGORY, EVENT_NAME } from '@/constants/analytics'
import DragAndDropMixin from '@/mixins/DragAndDropMixin'
import showAPIError from '@/utils/showAPIError'
import { mapActions } from 'vuex'

/**
 * This gives a rearrangeable goals list i.e Goals rendered in the list can be dragged within the list.
 */
export default {
  name: 'RearrangeableGoalsList',
  props: ['selectedTimeline', 'goals', 'orgId', 'source'],
  mixins: [DragAndDropMixin],
  components: {
    GoalViewer
  },
  data() {
    return {
      goalsContainerKey: 1
    }
  },
  computed: {},
  methods: {
    ...mapActions(['changeRank']),
    enableGoalDragAndDrop() {
      this.enableDragAndDrop({
        containers: [this.$refs.listContainer],
        onDrop: this.onDrop,
        handleName: 'goal-gripper'
      })
    },
    async onDrop({ afterId, beforeId, subjectId }) {
      try {
        await this.changeRank({
          orgId: this.orgId,
          type: 'goal',
          subjectId,
          beforeId,
          afterId
        })
        this.$emit('arrange', { subjectId, beforeId })
        trackEvent(EVENT_CATEGORY.ACTIVITY, EVENT_ACTION.REARRANGE, EVENT_NAME.GOAL)
      } catch (e) {
        // Revert the drag. Re-rendering the list
        this.goalsContainerKey++
        this.$nextTick(function() {
          this.enableGoalDragAndDrop()
        })
        showAPIError(e)
      }
    }
  },
  mounted() {
    this.enableGoalDragAndDrop()
  }
}
</script>

<style lang="scss" scoped></style>
